export type SolutionKey = 'strategy' | 'search' | 'leads' | 'ecommerce' | 'integrations' | 'managed'

export type Solution = {
  key: SolutionKey
  label: string
  headline: string
  lead: string
  body: string
  deliverables: string[]
  accent: 'orange' | 'green' | 'cyan'
}

export const solutions: Solution[] = [
  {
    key: 'strategy',
    label: 'Website strategy and design',
    headline: 'Shape the customer journey around the way you sell',
    lead: 'Strategy, structure, and design',
    body: 'Structure, content, and design follow your offers, buying process, brand, and existing search equity, so the path from first visit to first conversation is deliberate.',
    deliverables: [
      'Business and audience mapping',
      'Information architecture',
      'Custom design system',
      'Content migration, redirects, and launch QA',
    ],
    accent: 'orange',
  },
  {
    key: 'search',
    label: 'SEO, content, and paid search',
    headline: 'Create demand in the markets that matter',
    lead: 'Qualified demand',
    body: 'We set priorities across technical SEO, content, landing pages, and Google Ads support, then tie the work to qualified traffic and the actions that move the business.',
    deliverables: [
      'Service and location strategy',
      'Technical and on-page SEO',
      'Content and landing-page development',
      'Google Ads and conversion-tracking support',
    ],
    accent: 'cyan',
  },
  {
    key: 'leads',
    label: 'Lead capture and communication',
    headline: 'Turn interest into an actionable next step',
    lead: 'Calls, forms, quotes, booking, and chat',
    body: 'Calls, forms, quote requests, booking, text, and live chat are designed around how your team qualifies, routes, and follows up—not added as isolated widgets.',
    deliverables: [
      'Quote and intake workflows',
      'Call and booking paths',
      'Live chat configuration',
      'Lead routing and conversion improvements',
    ],
    accent: 'orange',
  },
  {
    key: 'ecommerce',
    label: 'Ecommerce and payments',
    headline: 'Support the pricing, product, and fulfillment rules you actually use',
    lead: 'Complex selling requirements',
    body: 'Complex products, customer pricing, account rules, tax, shipping, payment, and order handling are modeled the way your business runs them—without WebsiteForge taking a percentage of sales.',
    deliverables: [
      'Complex catalogs and product configuration',
      'Customer and wholesale pricing',
      'Checkout and payment configuration',
      'Order and fulfillment workflows',
    ],
    accent: 'green',
  },
  {
    key: 'integrations',
    label: 'Integrations and automation',
    headline: 'Move information without duplicate work',
    lead: 'Less manual handling',
    body: 'CRM, accounting, scheduling, inventory, billing, and internal tools exchange the right information so your team spends less time re-entering, routing, and reconciling data.',
    deliverables: [
      'API and system integrations',
      'Data synchronization',
      'Notifications and lead routing',
      'Custom business workflows',
    ],
    accent: 'cyan',
  },
  {
    key: 'managed',
    label: 'Hosting, support, and improvement',
    headline: 'Keep the system aligned as the business changes',
    lead: 'Ongoing management',
    body: 'The same team stays involved with hosting, security, content changes, reporting, search performance, conversion work, and new functionality.',
    deliverables: [
      'Managed hosting and security',
      'Content and configuration changes',
      'Reporting and ongoing optimization',
      'Support, training, and future development',
    ],
    accent: 'orange',
  },
]
